import { render, staticRenderFns } from "./ConfirmEndDraftModal.vue?vue&type=template&id=c9bcd6a8&scoped=true&"
import script from "./ConfirmEndDraftModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmEndDraftModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEndDraftModal.vue?vue&type=style&index=0&id=c9bcd6a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bcd6a8",
  null
  
)

export default component.exports